<template>
  <GameConfigWizard mode="create" />
</template>

<script>
import GameConfigWizard from '@/components/GameConfigWizard.vue';

export default {
  name: 'AddNewGame',
  components: { GameConfigWizard },
};
</script>
